module.exports = __webpack_public_path__ + "media/images/icon/4-f0ead771805b1374f668cff085ee5e16.svg";